<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.33398 4H14.0007" stroke="#0033A1" stroke-linecap="round"/>
<path d="M7.33398 8H14.0007" stroke="#0033A1" stroke-linecap="round"/>
<path d="M7.33398 12H14.0007" stroke="#0033A1" stroke-linecap="round"/>
<path d="M2 4.92792C2 4.92792 2.66667 5.36246 3 5.99935C3 5.99935 4 3.49935 5.33333 2.66602" stroke="#0033A1" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 12.2619C2 12.2619 2.66667 12.6965 3 13.3333C3 13.3333 4 10.8333 5.33333 10" stroke="#0033A1" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
